import { adminUrl } from 'api/api-constants';
import axios from 'api/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { extractData } from 'api/utils';
import { queryKey, urlPrefix } from './consts';

export function putWorkOrder(payload) {
	return axios
		.put(`${urlPrefix}`, payload, {
			baseURL: adminUrl,
		})
		.then(extractData);
}

export function usePutWorkOrder() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (payload) => putWorkOrder(payload),
		onSuccess: () => {
			// Invalidate and refetch
			queryClient.invalidateQueries({ queryKey: [queryKey] });
		},
	});
}
